import React, { useEffect, useState } from 'react';
import { Table, Button, Image, Typography, Space, Input } from 'antd';
import axios from 'axios';
import config from '../../config';
import { toast } from 'react-toastify';
import { SearchOutlined } from '@ant-design/icons';
const { Text } = Typography;


const SelectPackageModal = ({ object, onSuccess }) => {

    const [packages, setPackages] = useState([]);
    const [initialized, setInitialized] = useState(false);
    const [selectedMap, setSelectedMap] = useState(new Map());
    const [allPackages, setAllPackages] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedPackages, setSelectedPackages] = useState([]);
    const [btnStatus, setBtnStatus] = useState(true);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 8,
        total: 0,
    });

const [searchFilters, setSearchFilters] = useState({
        title: ""
    });

    const fetchPackagesWithFilter = async (page = pagination.current, pageSize = pagination.pageSize) => {
        try {
            setLoading(true);

            let dynamicFilter = "";
            if (searchFilters.title) {
                dynamicFilter += `title=*${searchFilters.title}/i`;
            }

            const userId = object.userID;
            const response = await axios.post(
                `${config.apiBaseUrl}/api/Package/getUserPackages`,
                userId,
                {
                    params: {
                        page,
                        pageSize,
                        filter: dynamicFilter,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        HeaderKey: config.HeaderKey,
                    },
                    withCredentials: true,
                }
            );

            setPackages(response.data.data);
            setPagination(prev => ({
                ...prev,
                current: page,
                pageSize,
                total: response.data.count || 0,
            }));
        } catch (error) {
            toast.error(<p dir="rtl" className="font-custom">جستجو با خطا مواجه شد</p>);
            if (error.response && error.response.status === 401) {
                toast.error(<p dir="rtl" className="font-custom">شما دسترسی انجام این عملیات را ندارید</p>);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSearchChange = (e, columnName) => {
        let value = e.target.value;

        const newFilters = {
            ...searchFilters,
            [columnName]: value
        };

        setSearchFilters(newFilters);

        const filteredData = allPackages.filter(pkg => {
            return (
                (!newFilters.title || pkg.title.toLowerCase().includes(newFilters.title.toLowerCase()))
            );
        });

        setPackages(filteredData);
    };
    const handleSubmit = async () => {
        const userId = object.userID;
        try {
            const payload = {
                userId: userId,
                courseId: selectedRowKeys,
            };
            console.log('Submitting payload:', payload);
            const response = await axios.post(`${config.apiBaseUrl}/api/Package/AssignUserToPackage`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'HeaderKey': config.HeaderKey,
                },
                withCredentials: true,
            });

            if (response.data.success) {
                toast.success(<p dir="rtl" className="font-custom">دسترسی به بسته ها بروز شد</p>);
                onSuccess();
            } else {
                console.error('Assignment failed:', response.data.message);
            }
        } catch (error) {
            console.error('Error assigning packages:', error);
        }
    };
    

    const fetchPackages = async (page = 1, pageSize = 8) => {
        setLoading(true);
        const userId = object.userID;
        try {
            const response = await axios.post(`${config.apiBaseUrl}/api/Package/getUserPackages`, userId, {
                params: { page, pageSize },
                headers: {
                    "Content-Type": "application/json",
                    'HeaderKey': config.HeaderKey,
                },
                withCredentials: true,
            });

            const fetchedPackages = response.data.data || [];

            const preselectedKeys = fetchedPackages.filter((pkg) => pkg.hasAccess).map((pkg) => pkg.id);

            setPackages(fetchedPackages);
            setAllPackages(fetchedPackages);

            // Merge any newly discovered preselected keys from this page into the global selection
            setSelectedRowKeys((prev) => {
                const merged = Array.from(new Set([...(prev || []), ...preselectedKeys]));
                return merged;
            });

            // Add package objects for preselected items into the selectedMap and update selectedPackages
            setSelectedMap((prev) => {
                const next = new Map(prev);
                fetchedPackages
                    .filter((p) => preselectedKeys.includes(p.id))
                    .forEach((p) => next.set(p.id, p));
                setSelectedPackages(Array.from(next.values()));
                return next;
            });

            if (!initialized) {
                setInitialized(true);
            }
            setPagination((prev) => ({
                ...prev,
                current: page,
                pageSize,
                total: response.data.count || 0,
            }));
        } catch (err) {
            console.error('Error fetching packages:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPackages();
    }, []);

    const onSelectChange = (newSelectedRowKeys, selectedRows) => {
        setSelectedRowKeys(newSelectedRowKeys);

        setSelectedMap((prev) => {
            const next = new Map(prev);
            // add/update current page selections
            selectedRows.forEach(p => next.set(p.id, p));
            // remove anything that's no longer selected across all pages
            for (const key of Array.from(next.keys())) {
                if (!newSelectedRowKeys.includes(key)) next.delete(key);
            }
            // update selectedPackages from the next map
            setSelectedPackages(Array.from(next.values()));
            return next;
        });

        setBtnStatus(false);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        preserveSelectedRowKeys: true,
    };

    const columns = [
        {
            dataIndex: 'imageUrl',
            key: 'imageUrl',
            align:'center',
            width:20,
            height:20,
            render: (url) => <Image width={60} height={40} src={config.apiBaseUrl + url} alt="Package" />,
        },
        {
            title: 'تعداد دوره‌ها',
            dataIndex: 'courseCount',
            key: 'courseCount',
            align:'center',
            className:'font-custom ',
        },
        {
            title: 'عنوان بسته',
            dataIndex: 'title',
            key: 'title',
            align:'right',
            className:'font-custom',
            filterDropdown: () => (
                <div style={{ padding: 8 }} className="font-custom">
                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            className="font-custom"
                            placeholder="جستجوی عنوان بسته"
                            allowClear
                            onClear={() => {
                                // Reset the search filter and re-fetch data
                                setSearchFilters((prevState) => ({
                                    ...prevState,
                                    title: "",
                                }));
                            }}
                            value={searchFilters.title}
                            onChange={(e) => {
                                handleSearchChange(e, "title");
                            }}
                            onPressEnter={() => {
                                fetchPackagesWithFilter();
                            }}
                        />
                        <Button type="primary"
                            icon={<SearchOutlined />}
                            onClick={() => {
                                // Server-side search when button is clicked
                                fetchPackagesWithFilter();
                            }}
                        />
                    </Space.Compact>
                </div>
            ),
            render: (text) => <Text strong>{text}</Text>,
        },
        
    ];
    return (
        <div className="font-custom">
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={packages}
                    rowKey="id"
                    className='font-custom'
                    loading={loading}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        onChange: (page, pageSize) => {
                            setPagination((prev) => ({ ...prev, current: page, pageSize }));
                            fetchPackages(page, pageSize);
                        },
                    }}
                />
                <div className='text-center'>
                    <Button
                        type="primary"
                        className="font-custom"
                        onClick={handleSubmit}
                        disabled={btnStatus}
                    >
                        ثبت تغییرات
                    </Button>
                </div>

                {selectedPackages.length > 0 && (
                    <div className="text-right">
                        <Text type="success" className='font-custom'>تعداد بسته انتخاب شده: {selectedPackages.length}</Text>
                    </div>
                )}
            </Space>
        </div>
    )
}

export default SelectPackageModal